import { DOC_KIND } from "NSI";
import { VOLTAGE_LEVEL_KIND } from "NSI";
import { VOLTAGE_SIDE_T2_SPLIT } from "NSI";
import { TRANSFORMER_TYPES } from "NSI";
import { VOLTAGE_SIDE_T3 } from "NSI";
import { VOLTAGE_SIDE_T2 } from "NSI";
import { CALC_MODE } from "NSI";

import { CT_PLACE } from "NSI";
import { PROTECTION } from "NSI";

export const localStorageKey = 'auth-token';

// Роли пользователей
export const USER_ROLES = Object.freeze({
    ADMIN: 'администратор',
    MANAGER: 'руководитель',
    DESIGNER: 'проектировщик',
    ORG_ADMIN: 'администратор предприятия'
});

export const PHONE_REGEX = /^(\+7|8)?[\s\-]?\(?[0-9]{3}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
export const EMAIL_REGEX = /\S+@\S+\.\S+/;

export const ERROR_CREATE_ORG = "Ошибка при создании организации";
export const ERROR_UPDATE_ORG = "Ошибка при обновлении организации";
export const ERROR_DELETE_ORG = "Ошибка при удалении организации";
export const ERROR_CREATE_DEPT = "Ошибка при создании организации";
export const ERROR_UPDATE_DEPT = "Ошибка при обновлении организации";
export const ERROR_DELETE_DEPT = "Ошибка при удалении организации";
export const ERROR_RETRIEVE_DEPT = "Ошибка при получении подразделения с ID: ";

export const ERROR_CREATE_USER = "Ошибка создания пользователя";
export const ERROR_UPDATE_USER = "Ошибка обновления пользователя";

export const SNACKBAR_MSG_TYPE_ERROR = "error";
export const SNACKBAR_MSG_TYPE_SUCCESS = "success";
export const SNACKBAR_MSG_TYPE_WARNING = "warning";

export const SUCCESS_MSG_ORG_CREATE = "Организация успешно создана";
export const SUCCESS_MSG_ORG_UPDATE = "Организация успешно обновлена";
export const SUCCESS_MSG_ORG_DELETE = "Организация успешно удалена";

export const SUCCESS_MSG_DEPT_CREATE = "Подразделение успешно создано";
export const SUCCESS_MSG_DEPT_UPDATE = "Подразделение успешно обновлено";
export const SUCCESS_MSG_DEPT_DELETE = "Подразделение успешно удалено";

export const THEME_SYSTEM = "system";
export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";
export const THEME_MODE_KEY = "themeMode";
export const THEME_MEDIA_QUERY_PREFER_DARK = "(prefers-color-scheme: dark)"

export const REFERENCE_TYPE_BOX_TYPE = "BOX_TYPE"
export const REFERENCE_TYPE_TERMINAL = "TERMINAL"
export const REFERENCE_TYPE_FUNCTION = "FUNCTION"
export const REFERENCE_TYPE_SETTING = "SETTING"
export const REFERENCE_TYPE_BOX = "BOX"
export const REFERENCE_TYPE_PROTECTION_TYPE = "PROTECTION_TYPE";

export const OBJECT_TYPE_LABELS = Object.freeze({
    organization: 'Организация',
    user: 'Пользователь',
    department: 'Подразделение',
    ct: 'ТТ',
    doc: 'Документ',
    t: 'Трансформатор',
    [REFERENCE_TYPE_BOX_TYPE]: 'Тип шкафа',
    [REFERENCE_TYPE_TERMINAL]: 'Терминал',
    [REFERENCE_TYPE_FUNCTION]: 'Функция РЗ',
    [REFERENCE_TYPE_SETTING]: 'Уставка',
    [REFERENCE_TYPE_PROTECTION_TYPE]: 'Вид защиты'
});

export const OBJECT_TYPE_USER = "user"
export const OBJECT_TYPE_ORGANIZATION = "organization"
export const OBJECT_TYPE_DEPARTMENT = "department"
export const OBJECT_TYPE_CT = "ct"
export const OBJECT_TYPE_DOC = "doc"
export const OBJECT_TYPE_TS = "t"

export const WITHOUT_NAME = 'Без названия'
export const WITHOUT_FULLNAME = 'Без имени'
export const DEPARTMENT_WITHOUT_NAME = 'Подразделение без названия'
export const ELEMENT = 'Элемент'

export const ENTITY_FIELD_LABELS = {
    [OBJECT_TYPE_ORGANIZATION]: {
        name: 'Название',
        inn: 'ИНН',
        address: 'Адрес',
        departments: 'Подразделения'
    },
    [OBJECT_TYPE_USER]: {
        fullName: 'ФИО',
        email: 'Email',
        login: 'Логин',
        phone: 'Телефон',
        department: 'Подразделение',
        // role: 'Роль',
        'role': 'Роль',
        'role.name': 'Название',
        about: 'Дополнительно'
    },
    [OBJECT_TYPE_DEPARTMENT]: {
        name: 'Название',
    },
    [OBJECT_TYPE_CT]: {
        название: 'Название',
    }
};

export const BOOLEAN_LABELS = {
    true: 'Да',
    false: 'Нет'
};

export const HIDDEN_FIELDS = [
    'id',
    '_id',
    'errors'
];

export const CLEAR_TRASH_TITLE = "Очистить корзину?";
export const CLEAR_TRASH_CONFIRM_CONTENT = "Вы уверены, что хотите безвозвратно удалить все элементы из корзины? Это действие нельзя отменить.";
export const CLEAR_TRASH_CONFRIM_TEXT = "Очистить"

export const DELETE_AVATAR_TITLE = "Удалить аватар?";
export const DELETE_AVATAR_CONFIRM_CONTENT = "Вы уверены, что хотите удалить аватар?";
export const DELETE_AVATAR_CONFRIM_TEXT = "Удалить"

export const INFORMATION_NOT_FOUND = "Информация не найдена"

export const ERROR_DURING_UPLOAD_AVATAR = "Ошибка при загрузке аватара";
export const ERROR_DURING_DELETE_AVATAR = "Ошибка при удалении аватара";

export const SUCCESSFUL_DELETE_AVATAR = "Успешное удаление аватара";

export const TABLE_STATES_KEY = 'tableStates';

export const COMPLEX_NUMBER_TYPE = Object.freeze({
    ALGEBRAIC: { code: "algebraic", value: "Алгебраический" },
    TRIGONOMETRIC: { code: "trigonometric", value: "Тригонометрический" },
    TA: { code: 'Ta', value: 'Ta' },
})

export const INITIAL_DOC = (kind, calcMode = CALC_MODE.INTERNAL) => ({
    kind,
    project: '',
    date: new Date(),
    config: {
        
    },
    expData: {
        calc_mode: calcMode,
        ТТ: {
            Kат: 1,
            паспорт: kind === DOC_KIND.CHECK || kind === DOC_KIND.TNAS ? { id: '', } : {},
        }
    }
})

export const REFERENCE_TYPE_CT = "CT";

export const SUPPORTED_SCHEME_LOGIC = {
    ЛЭП_ВЛ: 'ЛЭП_ВЛ',
    Т_T2: 'Т_T2',
    Т_T2_SPLIT: 'Т_T2_SPLIT',
    Т_T3: 'Т_T3',
    Т_AT: 'Т_AT'
}

export const LAYER = Object.freeze({
    // ТТ в цепях ЛЭП
    CT_LINE: 'CT_Line',

    // ТТ в цепях Выключателя
    CT1_IN_ZONE:  'CT1_2', // В1 в зоне
    CT1_OUT_ZONE: 'CT1_1', // В1 вне зоны
    CT2_IN_ZONE:  'CT2_2', // В2 в зоне
    CT2_OUT_ZONE: 'CT2_1', // В2 вне зоны

    // Точки К1 (ТТ в цепи выключателя)
    F1_1: 'К1.1', // ТТ2, В1 в зоне
    F1_2: 'К1.2', // ТТ2, В1 не в зоне, ТТ1 невстроенный
    F1_3: 'К1.3', // ТТ1, В2 не в зоне, ТТ2 невстроенный
    F1_4: 'К1.4', // ТТ1, В2 в зоне

    // Точки К1/К2 (ТТ в цепи линии)
    F1_LINE: 'К1.Л',
    F2_LINE: 'К2.Л',

    // Точки K1/К2 (ТТ в цепи выключателя)
    F1_Q: 'К1.В',
    F2_Q: 'К2.В',

    // Прочие точки КЗ
    F1: 'К1',
    F2: 'К2',
    F3: 'К3',
    F4: 'К4',
    F5: 'К5',
    F6: 'К6',

    // АТ (отображается всегда)
    AT: 'AT',

    // Выключатели (отключены)
    Q1: 'В1',
    Q1_on: 'В1_on',
    Q1_off: 'В1_off',
    Q2: 'В2',
    Q2_on: 'В2_on',
    Q2_off: 'В2_off',
    Q3: 'В3',
    Q3_on: 'В3_on',
    Q3_off: 'В3_off',
    Q4: 'В4',
    Q4_on: 'В4_on',
    Q4_off: 'В4_off',
    Q5: 'В5',
    Q6: 'В6',
    Q7: 'В7',
    Q10: 'В10',
    
    Q1LA: 'ВЛ1А',
    Q1LA_on: 'ВЛ1А_on',
    Q1LA_off: 'ВЛ1А_off',
    
    Q1LB: 'ВЛ1В',
    Q1LB_on: 'ВЛ1В_on',
    Q1LB_off: 'ВЛ1В_off',
    
    Q2LA: 'ВЛ2А',
    Q2LA_on: 'ВЛ2А_on',
    Q2LA_off: 'ВЛ2А_off',
    
    Q2LB: 'ВЛ2В',
    Q2LB_on: 'ВЛ2В_on',
    Q2LB_off: 'ВЛ2В_off',
    
    Q1M: 'В1ГЭ',
    Q1M_on: 'В1ГЭ_on',
    Q1M_off: 'В1ГЭ_off',
    
    Q2M: 'В2ГЭ',
    Q2M_on: 'В2ГЭ_on',
    Q2M_off: 'В2ГЭ_off',
    
    QM: 'ВГЭ',
    QM_on: 'ВГЭ_on',
    QM_off: 'ВГЭ_off',
    
    SV: 'SW',
    SV_on: 'СВ_on',
    SV_off: 'СВ_off',

    // Вторая цепь
    LINE_2:           'Line_2',
    GROUND_1: 'ЗР1_on',
    GROUND_2: 'ЗР2_on',
    
    // Т1 — РПН
    T1_RPN_NN: 'Т1_РПН_НН',
    T1_RPN_SN: 'Т1_РПН_СН',
    T1_RPN_VN: 'Т1_РПН_ВН',

    // Т2 — РПН
    T2_RPN_NN: 'Т2_РПН_НН',
    T2_RPN_SN: 'Т2_РПН_СН',
    T2_RPN_VN: 'Т2_РПН_ВН',

    // Т2 — НН
    T2_NN_Yn_I: 'Т2_НН_Ун_И',
    T2_NN_Yn_Z: 'Т2_НН_Ун_З',
    T2_NN_Y:    'Т2_НН_У',
    T2_NN_D:    'Т2_НН_Д',

    // Т2 — СН
    T2_SN_Yn_I: 'Т2_СН_Ун_И',
    T2_SN_Yn_Z: 'Т2_СН_Ун_З',
    T2_SN_Y:    'Т2_СН_У',
    T2_SN_D:    'Т2_СН_Д',

    // Т2 — ВН
    T2_VN_Yn_I: 'Т2_ВН_Ун_И',
    T2_VN_Yn_Z: 'Т2_ВН_Ун_З',
    T2_VN_Y:    'Т2_ВН_У',
    T2_VN_D:    'Т2_ВН_Д',

    // Т1 — НН
    T1_NN_Yn_I: 'Т1_НН_Ун_И',
    T1_NN_Yn_Z: 'Т1_НН_Ун_З',
    T1_NN_Y:    'Т1_НН_У',
    T1_NN_D:    'Т1_НН_Д',

    // Т1 — СН
    T1_SN_Yn_I: 'Т1_СН_Ун_И',
    T1_SN_Yn_Z: 'Т1_СН_Ун_З',
    T1_SN_Y:    'Т1_СН_У',
    T1_SN_D:    'Т1_СН_Д',

    // Т1 — ВН
    T1_VN_Yn_I: 'Т1_ВН_Ун_И',
    T1_VN_Yn_Z: 'Т1_ВН_Ун_З',
    T1_VN_Y:    'Т1_ВН_У',
    T1_VN_D:    'Т1_ВН_Д',

    // РПН
    RPN_SN: 'РПН_СН',
    RPN_NN: 'РПН_НН',
    RPN_VN: 'РПН_ВН',

    // СН
    SN_Yn_I: 'СН_Ун_И',
    SN_Yn_Z: 'СН_Ун_З',
    SN_Yn:    'СН_У',
    SN_D:    'СН_Д',

    // НН
    NN_Yn_I: 'НН_Ун_И',
    NN_Yn_Z: 'НН_Ун_З',
    NN_Y:    'НН_У',
    NN_D:    'НН_Д',

    // ВН
    VN_Yn_I: 'ВН_Ун_И',
    VN_Yn_Z: 'ВН_Ун_З',
    VN_Y:    'ВН_У',
    VN_D:    'ВН_Д',

    // НН2
    NN2_Yn_I: 'НН2_Ун_И',
    NN2_Yn_Z: 'НН2_Ун_З',
    NN2_D:    'НН2_Д',
    NN2_Y:    'НН2_У',

    // НН1
    NN1_Yn_I: 'НН1_Ун_И',
    NN1_Yn_Z: 'НН1_Ун_З',
    NN1_Y:    'НН1_У',
    NN1_D:    'НН1_Д',
});

export const DEFAULT_SWITCH_LAYERS_BY_KIND = {
    [TRANSFORMER_TYPES.T3]: ['СВ_on'],
    [TRANSFORMER_TYPES.AT]: ['В1_on', 'В2_on', 'В3_on', 'В4_on'],

    [VOLTAGE_LEVEL_KIND.B_1]:   ['ВЛ1А_on', 'ВЛ1В_on', 'ВЛ2А_on', 'ВЛ2В_on', 'ВЛ2В_on', 'ВГЭ_on'],
    [VOLTAGE_LEVEL_KIND.B_2]:   ['ВЛ1В_on', 'В1_on', 'В2_on', 'ВЛ2В_on', 'ВЛ2А_on', 'В1ГЭ_on', 'В2ГЭ_on'],
    [VOLTAGE_LEVEL_KIND.B_3_2]: ['В1_on', 'В2_on', 'В3_on', 'ВЛ1В_on', 'ВЛ2А_on', 'ВЛ2В_on', 'В1ГЭ_on', 'В2ГЭ_on'],
    [VOLTAGE_LEVEL_KIND.MANY]:  ['В1_on', 'В2_on', 'ВЛ1В_on', 'ВЛ2В_on', 'ВЛ2А_on', 'В1ГЭ_on', 'В2ГЭ_on'],
};

export const MANAGED_LAYERS = Object.freeze(Object.values(LAYER));

const SCHEME_FILES = Object.freeze({
    'scheme_1В': [VOLTAGE_LEVEL_KIND.B_1],
    'scheme_2В': [VOLTAGE_LEVEL_KIND.B_2, VOLTAGE_LEVEL_KIND.TB_2],
    'scheme_3_2': [VOLTAGE_LEVEL_KIND.B_3_2, VOLTAGE_LEVEL_KIND.TB_3_2],
    'scheme_4_3': [VOLTAGE_LEVEL_KIND.B_4_3],
    'scheme_many': [VOLTAGE_LEVEL_KIND.MANY],
});

export const SCHEME_CONFIGURATIONS = Object.freeze(
    Object.entries(SCHEME_FILES).reduce((acc, [file, vlTypes]) => {
        vlTypes.forEach(type => {
            acc[type] = file;
        });
        return acc;
    }, {})
)

export const WINDING_SIDES = {
    [TRANSFORMER_TYPES.T2]:       Object.values(VOLTAGE_SIDE_T2),
    [TRANSFORMER_TYPES.T2_SPLIT]: Object.values(VOLTAGE_SIDE_T2_SPLIT),
    [TRANSFORMER_TYPES.T3]:       Object.values(VOLTAGE_SIDE_T3),
    [TRANSFORMER_TYPES.AT]:       Object.values(VOLTAGE_SIDE_T3),
}

/** Подписи области трансформатора для полей режима нейтрали (основной / смежный). */
export const NEUTRAL_MODE_SCOPE = Object.freeze({
    main: 'основной',
    adjacent: 'смежный',
});